module.exports = __webpack_public_path__ + "img/cognitivo.4e51a8c6.png";